module.exports = __webpack_public_path__ + "img/bg_avatar_male_75.b08034d9.png";